import { render } from "./LocatorForm.vue?vue&type=template&id=cf42a794&ts=true"
import script from "./LocatorForm.vue?vue&type=script&lang=ts"
export * from "./LocatorForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__